import gql from 'graphql-tag';

const GET_ALL_EMPLOYEES = gql`
  query {
    getAllEmployees {
      userId
      firstName
      lastName
      email
      phoneNumber
      countryCode
      designation {
        designationId
        name
      }
      businessFunction {
        businessFunctionId
        name
      }
      team {
        teamId
        name
      }
    }
  }
`;

const GET_ALLMSP_DESIGNATIONS = gql`
  query {
    getDesignationList {
      designationId
      name
    }
  }
`;

const GET_MSP_BUSINESSFUNCTIONS = gql`
  query {
    getBusinessFunctionList {
      businessFunctionId
      name
    }
  }
`;

const GET_MSP_TEAMLIST = gql`
  query {
    getTeamList {
      teamId
      name
    }
  }
`;

const GET_ALL_SITE = gql`
  query {
    getAllSite {
      name
    }
  }
`;

const GET_CLIENT_USERS = gql`
  query($input: GetClientUsersListInput!) {
    getClientUserAssociationsList(input: $input) {
      associations {
        user {
          userId
          firstName
          lastName
          email
          phoneNumber
          contactNumber
          countryCode
          name
          loginRequired
          contactType
          reportingManager {
            userId
            firstName
            lastName
            email
          }
          site {
            id
            name
          }
          account {
            accountId
          }
          role {
            roleId
            name
            roleType {
              name
              type
            }
          }
        }
      }
    }
  }
`;

const GET_CLIENT_USER = gql`
  query($userId: ID!, $userCustomFields: Boolean!) {
    getClientUser(userId: $userId) {
      userId
      firstName
      lastName
      email
      phoneNumber
      contactNumber
      countryCode
      activated
      activationMailStatus
      activationMailFailureReason
      splashtopWFHEnabled
      remoteDesktopAddOnEnabledStatus
      # contactType
      role {
        roleId
        name
      }
      reportingManager {
        userId
        firstName
        lastName
        email
      }
      site {
        id
        name
      }
      customFields @include(if: $userCustomFields)
      associations {
        id
        client {
          name
          accountId
        }
        site {
          id
          name
          hq
        }
        primarySite
      }
    }
  }
`;

// query($userId: ID!) {
//   getClientUser(userId: $userId) {
//     userId
//     firstName
//     lastName
//     email
//     phoneNumber
//     contactNumber
//     countryCode
//     # contactType
//     role {
//       roleId
//       name
//     }
//     reportingManager {
//       userId
//       firstName
//       lastName
//       email
//     }
//     site {
//       id
//       name
//     }
// associations {
//   id
//   client {
//     name
//     accountId
//   }
//   site {
//     id
//     name
//   }
// }
//   }
// }

const DELETE_CLIENT_USER = gql`
  mutation($userId: ID!) {
    deleteUser(userId: $userId)
  }
`;

const DELETE_CLIENT_USERS = gql`
  mutation($ids: [ID]!, $forget: Boolean) {
    deleteClientUser(ids: $ids, forget: $forget)
  }
`;

const DELETE_CLIENT_USERS_ASSOCIATIONS = gql`
  mutation($ids: [ID]!, $forget: Boolean) {
    deleteClientUserAssociations(ids: $ids, forget: $forget)
  }
`;

const CHECK_USER_EMAIL = gql`
  mutation(
    $email: String!
    $accountType: AccountType!
    $validateDomain: Boolean!
    $clientId: ID
  ) {
    checkUserEmailAddressAvailability(
      input: {
        email: $email
        accountType: $accountType
        validateDomain: $validateDomain
        clientId: $clientId
      }
    ) {
      status
      userId
    }
  }
`;

const GET_COMPANY_INFO = gql`
  query {
    getCompanyInfo {
      customDomain
      portalDomain
      currency
      language
      dateFormat
      timeFormat
      timezoneCode
      activatedDateTime
      daysSinceActivated
      businessHour {
        day
        start
        end
      }
    }
  }
`;

export {
  GET_CLIENT_USERS,
  DELETE_CLIENT_USER,
  DELETE_CLIENT_USERS,
  DELETE_CLIENT_USERS_ASSOCIATIONS,
  GET_CLIENT_USER,
  GET_ALL_SITE,
  CHECK_USER_EMAIL,
  GET_COMPANY_INFO
};
